export default __webpack_public_path__ + "static/media/90s_column@2x.f56712bb.png";